import { Component, OnInit } from '@angular/core';
import { LoaderService } from '@fapp/base';
import { distinctUntilChanged, Observable } from 'rxjs';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit {
  title = 'LSH';
  isLoading: Observable<boolean>;

  constructor(private loader: LoaderService) {}

  ngOnInit() {
    this.isLoading = this.loader.isLoading.pipe(distinctUntilChanged());
  }
}
